// extracted by mini-css-extract-plugin
module.exports = {"nav-tab-button-container":"nav-tab-button-container-r8HUb","icon":"icon-vxKmB","label":"label-mc9eB","logo":"logo-ST06l"};